var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconLogoutFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v25h15.333V13.75H7.39v-2.5h8.944V0H1zm15.333 11.25v2.5h2.556v3.75l5.111-5-5.111-5v3.75h-2.556z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconLogoutFilled;